import React from 'react';
import { Route } from 'react-router';
import { LoginPage } from '../../core/components/LoginPage/LoginPage';

export const LoginContainer = () => (
  <div className="inner-content-wrapper">
    <Route path="/login" component={LoginPage} />
  </div>
);
